import { ProductCategoryAPI } from "../api";

export class ProductCategory {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
    this.lable = ""
    if (this.erpId) this.lable += this.erpId + " "
    if (this.name) this.lable += this.name + " "
    if (this.name_en) this.lable += this.name_en
  }
  static async getProductCategoies(payload) {
    const { data } = await ProductCategoryAPI.getProductCategoies(payload);
    return data.result.map(item => new ProductCategory(item));
  }
  static async updateProductCategory(payload) {
    const { data } = await ProductCategoryAPI.updateProductCategory(payload);
    return new ProductCategory(data.result);
  }
  static async createProductCategory(payload) {
    const { data } = await ProductCategoryAPI.createProductCategory(payload);
    return new ProductCategory(data.result);
  }
}
